import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'overview-detail-page',
  templateUrl: './overview-detail-page.component.html',
  styleUrls: ['./overview-detail-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverviewDetailPageComponent {
  constructor() {}
}
